import React from 'react';
import { Row, Col } from 'antd';
import { FormattedMessage, useIntl } from 'react-intl';
import styles from './index.module.less';
import image from './faq.png';
import { Link } from '../../../utils/i18n';
import { useFaqs } from '../../../assets/faqs/index';
import TrackClick from '../../../components/Onetrack/TrackClick';
const windowWidth: Number = window.innerWidth
const isMobile: Boolean = windowWidth < 1000

const tips = [
  '71.1.1.1.2147',
  '71.1.1.1.2148',
  '71.1.1.1.2149',
  '71.1.1.1.2150',
]

const Faq: React.FC = () => {
  const intl = useIntl();
  const dataSource = useFaqs().slice(0, 4);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <Row align="stretch" justify="space-around">
          <Col xs={24} xl={12}>
            <div className={styles.content}>
              <div className={styles.inner}>
                <TrackClick tip="71.1.1.1.2146">
                  <Link to="/faq" className={styles.title}>
                    <FormattedMessage id="FAQ" />
                  </Link>
                </TrackClick>
                <div className={styles.list}>
                  {dataSource.map(({ id, title }, index) => (
                    <TrackClick tip={tips[index]}>
                      <Link
                        key={id}
                        title={title}
                        to={`/faq#${id}`}
                        className={styles.item}
                      >
                        {title}
                      </Link>
                    </TrackClick>
                  ))}
                  <TrackClick tip="71.1.1.1.2151">
                    <Link
                      title={intl.formatMessage({ id: 'Home.Faq.ReadMore' })}
                      to={`/faq`}
                      style={{display:'block'}}
                      className={styles.item}
                    >
                      &gt;&gt;&gt;
                    </Link>
                  </TrackClick>
                </div>
              </div>
            </div>
          </Col>
          <Col xs={24} xl={12}>
            <div className={styles.content}>
              <img className={styles.image} src={image} alt="Faq" />
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
};
const FaqMobile: React.FC = () => {
  const intl = useIntl();
  const dataSource = useFaqs().slice(0, 4);

  return (
    <div className={styles.wrapper}>
      <div className={styles.container}>
        <Row align="stretch" justify="space-around">
          <Col xs={24} xl={12}>
            <div className={styles.content}>
              <img className={styles.image} src={image} alt="Faq" />
            </div>
          </Col>
          <Col xs={24} xl={12}>
            <div className={styles.content}>
              <div className={styles.inner}>
                <TrackClick tip="71.1.1.1.2146">
                  <Link to="/faq" className={styles.title}>
                    <FormattedMessage id="FAQ" />
                  </Link>
                </TrackClick>
                <div className={styles.list}>
                  {dataSource.map(({ id, title }, index) => (
                    <TrackClick tip={tips[index]}>
                      <Link
                        key={id}
                        title={title}
                        to={`/faq#${id}`}
                        className={styles.item}
                      >
                        {title}
                      </Link>
                    </TrackClick>
                  ))}
                  <TrackClick tip="71.1.1.1.2151">
                    <Link
                      title={intl.formatMessage({ id: 'Home.Faq.ReadMore' })}
                      to={`/faq`}
                      className={styles.item}
                    >
                      &gt;&gt;&gt;
                    </Link>
                  </TrackClick>
                </div>
              </div>
            </div>
          </Col>
          
        </Row>
      </div>
    </div>
  );
};

export default isMobile ? FaqMobile : Faq;;
